export default "__VITE_ASSET__476491db__"